import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  redirect: '/load',
  meta: {
    keepAlive: true
  },
},
{
  path: '/load',
  name: 'load',
  meta: {
    keepAlive: false
  },
  component: () => import('../views/load.vue')
},
{
  path: '/index',
  name: 'index',
  meta: {
    keepAlive: true
  },
  component: () => import('../views/Index.vue')
},
{
  path: '/order',
  name: 'order',
  meta: {
    keepAlive: false
  },
  component: () => import('../views/order.vue')
},
{
  path: '/user',
  name: 'user',
  meta: {
    keepAlive: true
  },
  component: () => import('../views/user.vue')
},
{
  path: '/house',
  name: 'house',
  meta: {
    keepAlive: false
  },
  component: () => import('../views/fangjia.vue')
},
{
  path: '/jisuan',
  name: 'jisuan',
  meta: {
    keepAlive: false
  },
  component: () => import('../views/jisuan.vue')
},
{
  path: '/detail',
  name: 'detail',
  meta: {
    keepAlive: false
  },
  component: () => import('../views/detail.vue')
},
{
  path: '/load',
  name: 'load',
  meta: {
    keepAlive: false
  },
  component: () => import('../views/fangdai.vue')
},
{
  path: '/result',
  name: 'result',
  meta: {
    keepAlive: false
  },
  component: () => import('../views/result.vue')
},
{
  path: '/imgList',
  name: 'imgList',
  meta: {
    keepAlive: false
  },
  component: () => import('../views/imgList.vue')
},
{
  path: '/querylist',
  name: 'querylist',
  meta: {
    keepAlive: false
  },
  component: () => import('../views/querylist.vue')
}
]

const router = new VueRouter({
  routes,
  mode: 'history',
})

export default router